let getLoadingBarTpl = function () {
  return '<div class="loadingbar"></div>';
};

export { getLoadingBarTpl };


// WEBPACK FOOTER //
// ./_src/js/model/tpl/loadingbar.js